/********************************************************************
* Created ON:31/12/2018
* Created by: Avaya
* Description: Component for showing policy.
* Revision History:
* Modification date:
* Description: T
**********************************************************************/
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NodeService } from '../../services/node.service';
import { StorageService } from '../../services/storage.service';
import { MuteService } from '../../services/mute.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-sla',
  templateUrl: './sla.component.html',
  styleUrls: ['./sla.component.css']
})
export class SlaComponent implements OnInit {
  public allAudioTags: any;
  constructor(private router: Router,
    private bsmodalref: BsModalRef,
    private nodeService: NodeService,
    private storageService: StorageService,
    private muteService: MuteService
  ) { }

  ngOnInit() {
    this.muteService.muteFun();
  }
  /**
   * Function to close open modal
   */
  public modalClose = () => {
    this.bsmodalref.hide();
    this.nodeService.addNode({ modalopen: false });
    this.router.navigate(['']);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/component/sla/sla.component.ts